var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1693467577939,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1767,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128 874.666667v-725.333334c0-25.173333 14.506667-47.36 35.84-57.6L584.106667 512l-420.266667 420.266667c-21.333333-10.666667-35.84-32.426667-35.84-57.6m589.226667-229.546667L258.133333 910.506667l362.24-362.24 96.853334 96.853333m142.933333-183.893333c14.506667 11.52 25.173333 29.44 25.173333 50.773333s-9.386667 38.4-24.32 50.346667l-97.706666 56.32-106.666667-106.666667 106.666667-106.666667 96.853333 55.893334M258.133333 113.493333l459.093334 265.386667-96.853334 96.853333-362.24-362.24z",
    fill: "#ffffff",
    "p-id": 1768
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterGoogle);
export default __webpack_public_path__ + "static/media/footer-google.e885ea33af75e2a0c11b9a4b7f1fe421.svg";
export { ForwardRef as ReactComponent };